<template>
  <div data-scroll-container-default>
    <slot />
  </div>
</template>

<script>
import LocomotiveScroll from "locomotive-scroll";

export default {
  name: "SmoothScrollVert",
  data() {
    return {
      Loco: null,
      get_static_dist: 0,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    };
  },
  created: function() {},
  mounted() {
    // setTimeout(() => {
    //   console.log(this.get_static_dist);

    // }, 600);
   if (window.innerWidth <= 1023) {
   window.addEventListener("scroll", e => {
     let y = window.pageYOffset;
  
     
         if(document.querySelector(".history")){
          
                       y > (this.get_static_dist  - 680) ? document.querySelector("body").classList.add("orange")
            : document.querySelector("body").classList.remove("orange");
         
         }

    //     if (y > 90) {
    //       if (document.querySelector(".bar header")) {
    //         document.querySelector(".bar header").style.backgroundColor =
    //           "#F49CB8";
    //       }

    //       if (document.querySelector(".about header")) {
    //         document.querySelector(".about header").style.backgroundColor =
    //           "white";
    //       }
    //       if (document.querySelector(".news header")) {
    //         document.querySelector(".news header").style.backgroundColor =
    //           "white";
    //       }
    //       if (document.querySelector(".news-inner-page header")) {
    //         document.querySelector(
    //           ".news-inner-page header"
    //         ).style.backgroundColor = "white";
    //       }

    //       if (document.querySelector(".privacy-policy-page header")) {
    //         document.querySelector(
    //           ".privacy-policy-page header"
    //         ).style.backgroundColor = "white";
    //       }
    //     } else {
    //       if (document.querySelector(".bar header")) {
    //         document.querySelector(".bar header").style.backgroundColor =
    //           "transparent";
    //       }

    //       if (document.querySelector(".about header")) {
    //         document.querySelector(".about header").style.backgroundColor =
    //           "transparent";
    //       }

    //       if (document.querySelector(".news-inner-page header")) {
    //         document.querySelector(
    //           ".news-inner-page header"
    //         ).style.backgroundColor = "transparent";
    //       }
    //       if (document.querySelector(".news header")) {
    //         document.querySelector(".news header").style.backgroundColor =
    //           "transparent";
    //       }
    //       if (document.querySelector(".privacy-policy-page header")) {
    //         document.querySelector(
    //           ".privacy-policy-page header"
    //         ).style.backgroundColor = "transparent";
    //       }
    //     }

    //     if (y > 320) {
    //       if (
    //         document.querySelector(".history header") &&
    //         y <= this.get_static_dist - 20
    //       ) {
    //         // document.querySelector(".history header").style.backgroundColor = "#F1844D"
    //         document.querySelector(".history header").style.backgroundColor =
    //           "#FADD00";
    //         document.querySelector(
    //           "header .header-inner #jujuna-logo path"
    //         ).style.fill = "#044B30";
    //       } else if (
    //         document.querySelector(".history header") &&
    //         y >= this.get_static_dist - 20
    //       ) {
    //         document.querySelector(".history header").style.backgroundColor =
    //           "#F1844D";
    //         document.querySelector(
    //           "header .header-inner #jujuna-logo path"
    //         ).style.fill = "#262626";
    //       }
    //     } else {
    //       if (document.querySelector(".history header")) {
    //         document.querySelector(".history header").style.backgroundColor =
    //           "transparent";
    //       }
    //     }
   });
    }
    const locoScroll = new LocomotiveScroll({
      el: document.querySelector("[data-scroll-container-default]"),

      direction: "vertical",

      multiplier: 1,
      smooth: true,
      touchMultiplier: 6,
      firefoxMultiplier: 52,
      gestureDirection: "vertical",
      // repeat: true,
      // lerp: 0.15,
      initPosition: {
        x: 0,
        y: 0
      },
      tablet: {
        smooth: true,
        // direction: "vertical",

        breakpoint: 1024
      },
      smartphone: {
        breakpoint: 767,
        smooth: false
        // direction: "vertical"
      }
      // reloadOnContextChange: true,
    });

    this.Loco = locoScroll;

    this.Loco.destroy();

    this.$nextTick(function() {
      window.addEventListener("resize", this.onResize);
       
       if (window.innerWidth >= 1024) {
         if(document.querySelector(".history")) this.Loco.scrollTo(0,0);
      this.Loco.on("scroll", e => {
         if(document.querySelector(".history")){
          
                       e.delta.y > (this.get_static_dist  - 980) ? document.querySelector("body").classList.add("orange")
            : document.querySelector("body").classList.remove("orange");
         
         }

            
      //     if (e.delta.y > 90) {
      //       if (document.querySelector(".bar header")) {
      //         document.querySelector(".bar header").style.backgroundColor =
      //           "#F49CB8";
      //       }

      //       if (document.querySelector(".about header")) {
      //         document.querySelector(".about header").style.backgroundColor =
      //           "white";
      //       }
      //       if (document.querySelector(".news header")) {
      //         document.querySelector(".news header").style.backgroundColor =
      //           "white";
      //       }
      //       if (document.querySelector(".news-inner-page header")) {
      //         document.querySelector(
      //           ".news-inner-page header"
      //         ).style.backgroundColor = "white";
      //       }

      //       if (document.querySelector(".privacy-policy-page header")) {
      //         document.querySelector(
      //           ".privacy-policy-page header"
      //         ).style.backgroundColor = "white";
      //       }
      //     } else {
      //       if (document.querySelector(".bar header")) {
      //         document.querySelector(".bar header").style.backgroundColor =
      //           "transparent";
      //       }

      //       if (document.querySelector(".about header")) {
      //         document.querySelector(".about header").style.backgroundColor =
      //           "transparent";
      //       }

      //       if (document.querySelector(".news-inner-page header")) {
      //         document.querySelector(
      //           ".news-inner-page header"
      //         ).style.backgroundColor = "transparent";
      //       }
      //       if (document.querySelector(".news header")) {
      //         document.querySelector(".news header").style.backgroundColor =
      //           "transparent";
      //       }
      //       if (document.querySelector(".privacy-policy-page header")) {
      //         document.querySelector(
      //           ".privacy-policy-page header"
      //         ).style.backgroundColor = "transparent";
      //       }
      //     }

      //     if (e.delta.y > 320) {
      //       // console.log(e.delta.y);
      //       if (
      //         document.querySelector(".history header") &&
      //         e.delta.y <= this.get_static_dist - 20
      //       ) {
      //         // document.querySelector(".history header").style.backgroundColor = "#F1844D"
      //         document.querySelector(".history header").style.backgroundColor =
      //           "#FADD00";
      //         document.querySelector(
      //           "header .header-inner #jujuna-logo path"
      //         ).style.fill = "#044B30";
      //       } else if (
      //         document.querySelector(".history header") &&
      //         e.delta.y >= this.get_static_dist - 20
      //       ) {
      //         document.querySelector(".history header").style.backgroundColor =
      //           "#F1844D";
      //         document.querySelector(
      //           "header .header-inner #jujuna-logo path"
      //         ).style.fill = "#262626";
      //       }
      //     } else {
      //       if (document.querySelector(".history header")) {
      //         document.querySelector(".history header").style.backgroundColor =
      //           "transparent";
      //       }
      //     }
      });
      }
    });

    this.Loco.init();
    this.Loco.update();

    setTimeout(() => {
      this.Loco.update();
    }, 200);
    // setInterval(() => {
    //   this.Loco.update();
    // }, 10);
  },
  computed: {
   
    clickedOnCocktail() {
      return this.$store.state.main.clickedOnCocktail;
    },
    updateOnLoad() {
      return this.$store.state.main.current_content_request_status;
    },
    getBarScrollStatus() {
      return this.$store.state.main.disableLsOnBar;
    },
    getBarScrollStatusOut() {
      return this.$store.state.main.enableLsOnBar;
    },
    getScrollStatus() {
      return this.$store.state.main.scrollActive;
    },
    getReloadReq() {
      return this.$store.state.main.updateLs;
    },
    getReloadReq2() {
      return this.$store.state.main.updateLs2;
    },
    getReloadReq3() {
      return this.$store.state.main.updateLs3;
    },
    scrollToTop() {
      return this.$store.state.main.scrollToTop;
    },
    stopScrolling() {
      return this.$store.state.main.galleryTouch;
    }
  },
  watch: {
    clickedOnCocktail: {
      immediate: true,

      handler(ns, os) {
        if (ns == true) {
          setTimeout(() => {
            let target = this.$store.state.main.cocktailTarget;
            let _target = document.querySelector(`#cocktail-${target}`);
            // console.log(_target);
            if (ns == true) this.Loco.scrollTo(_target);
            // console.log(target)
            // console.log(this.Loco);
          }, 1000);
        }
      }
    },
    stopScrolling(newState, oldState) {
      if (newState == false) {
        this.Loco.start();
      } else if (newState == true) {
        this.Loco.stop();
      }
    },
    updateOnLoad: {
      immediate: true,
      handler(newState, oldState) {
        if (newState === "done") {
          // console.log("done");
          setTimeout(() => {
            this.Loco.update();
            if(document.querySelector("body").classList.contains("history")){
              let k = document.querySelector(".static-data-cont");
            this.get_static_dist = k.getBoundingClientRect().top;
            }
            
            // console.log(this.get_static_dist);
          }, 600);
        }
      }
    },
    getBarScrollStatus(newState, oldState) {
      if (newState) {
        this.Loco.stop();
        // console.log("stop");
      }
    },
    getBarScrollStatusOut(newState, oldState) {
      if (newState) {
        this.Loco.start();
        // console.log("start");
      }
    },
    scrollToTop() {
      this.Loco.scrollTo(0, 0);
    },
    getScrollStatus(newStatus, oldStatus) {
      if (newStatus == false) {
        this.Loco.stop();
      } else {
        this.Loco.start();
      }
    },
    getReloadReq2(ns, os) {
      this.Loco.update();
      this.Loco.scrollTo(0, 0);
      // console.log("updated");
    },
    getReloadReq3(ns, os) {
      this.Loco.update();

      // console.log("updated 3");
    },
    getReloadReq(newStatus, oldStatus) {
      this.Loco.update();

      setTimeout(() => {
        this.Loco.update();
      }, 300);

      // console.log("changeTab");
      if (newStatus == true) {
      }
    }
  },
  methods: {
    on_native_scroll(e) {
      // console.log(e);
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.Loco.update();
      // console.log(this.windowHeight,  this.windowWidth)
    },
    scrollStatus() {}
  },
  beforeDestroy() {
    this.Loco.destroy();
      window.removeEventListener("resize", this.onResize);

  },
  destroyed(){
    this.Loco.destroy();
    
    console.log(this.Loco)

  }
};
</script>

<style>
.custom-scroll {
  height: 100vh;
  overflow: auto;
}
</style>
